import React from 'react';
import {GREETINGS} from '../../../../../utils/constants/api';
import { GreetingFromApi } from '../../../../../shared/Greeting/data/GreetingFromApi';
import ConfirmDeleteModal from '../../../Layer/Modal/ConfirmDeleteModal';

type DeleteGreeting = {
    opened: boolean,
    onOk: () => void,
    onClose: () => any,
    greeting: GreetingFromApi
};

function DeleteGreeting(props: DeleteGreeting) {
    function deleteGreeting(): void {
        fetch(GREETINGS + '/' + props.greeting.id, {
            method: 'DELETE',
        })
            .then(response => {
                if (response.ok) {
                    props.onOk();
                } else {
                    response.json().then();
                }
            });
    }

    return (
        <ConfirmDeleteModal
            opened={ props.opened }
            modalTitle='Delete Greeting'
            cancelText='Cancel'
            deleteText={'<span>&laquo;' + props.greeting.value.text + '&raquo;</span>'}
            okText='Delete'
            onCancel={ props.onClose }
            onOk={ deleteGreeting }
        />
    )
}

export default DeleteGreeting;